import "./Features.css";

const features = [
  {
    title: "Live Broadcasting",
    desc: "Live streaming of talk shows, community announcements, and music directly to you",
    icon: "📡",
  },
  {
    title: "Community Focused",
    desc: "Content created by and for the community, celebrating local culture, voices and sports.",
    icon: "🤝",
  },
  {
    title: "Music & Culture",
    desc: "A diverse playlist spanning traditional sounds to modern hits, keeping you connected to your roots.",
    icon: "🎵",
  },
  {
    title: "Talk & Conversation",
    desc: "Engaging discussions on topics that matter, from local news to lifestyle and beyond.",
    icon: "🎙️",
  },
];

export default function Features() {
  return (
    <section className="features">
      <div className="features-inner">
        <div className="features-header">
          <h2 className="features-title">What We Offer</h2>
          <p className="features-sub">
            Your voice. Your music. Your stories. Your sports .... bringing the community together.
          </p>
        </div>
        <div className="features-grid">
          {features.map((f, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
